module.exports = __webpack_public_path__ + "static/media/fruits_33.1f46c181.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_33.csv
// module id = 699
// module chunks = 0